// The shared idle-activity clock: a single localStorage timestamp read/written
// by SessionTimeout (the idle auto sign-out) and CLEARED by authService on a
// deliberate sign-out. It lives in its own module so both sides can use it
// without a circular import (SessionTimeout already imports authService).
//
// Clearing it on sign-out matters on shared/school computers: otherwise a
// stale timestamp from the previous user could instantly bounce the next
// person's fresh sign-in (idle already > timeout) with no warning.
export const IDLE_ACTIVITY_KEY = 'stratia:last_activity';

export function readIdleActivity() {
    try {
        const v = parseInt(localStorage.getItem(IDLE_ACTIVITY_KEY) || '', 10);
        return Number.isFinite(v) ? v : null;
    } catch { return null; }
}

export function writeIdleActivity(ts) {
    try { localStorage.setItem(IDLE_ACTIVITY_KEY, String(ts)); } catch { /* storage off */ }
}

export function clearIdleActivity() {
    try { localStorage.removeItem(IDLE_ACTIVITY_KEY); } catch { /* storage off */ }
}
